var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { fill: "#FBBB00", d: "M3.546 9.669l-.557 2.08-2.036.042A7.964 7.964 0 0 1 0 8a7.96 7.96 0 0 1 .894-3.68l1.813.333.794 1.802a4.755 4.755 0 0 0 .045 3.214z" }),
      React.createElement("path", { fill: "#518EF8", d: "M15.86 6.505a8.009 8.009 0 0 1-.035 3.165 7.998 7.998 0 0 1-2.817 4.569l-2.283-.117-.323-2.017a4.768 4.768 0 0 0 2.052-2.435H8.176V6.505H15.86z" }),
      React.createElement("path", { fill: "#28B446", d: "M13.008 14.238A7.966 7.966 0 0 1 8 16a7.999 7.999 0 0 1-7.047-4.209L3.546 9.67a4.757 4.757 0 0 0 6.856 2.436l2.606 2.133z" }),
      React.createElement("path", { fill: "#F14336", d: "M13.106 1.842l-2.591 2.121A4.758 4.758 0 0 0 3.5 6.454L.895 4.322A7.998 7.998 0 0 1 8 0c1.941 0 3.72.691 5.106 1.842z" })
    )
  );
});